import React from 'react';
import { Button, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../../utils/localization';

import { invertedMessages } from './messages';
import { getFailedCaseText } from './utils';

function CertsListSidePanelBodyError({
  tab,
  retriggerApisForError,
  handleCloseSidePanel,
}) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='CertsSidePanelBody-tabContent--isError'>
      <Typography kind='h2'>{l("Couldn't Load")}</Typography>
      <Typography
        kind='body2'
        className='CertsSidePanelBody-tabContentDescription--isError'>
        {l(getFailedCaseText(tab))}
      </Typography>
      <Button
        type='button'
        kind='outlined'
        isEnabled
        onClick={retriggerApisForError}
        className='CertsSidePanelBody-tabContentRefreshBtn--isError'
        size='small'>
        {l('Refresh')}
      </Button>
      <Button
        type='button'
        kind='ghost'
        size='small'
        onClick={handleCloseSidePanel}>
        {l('Close')}
      </Button>
    </div>
  );
}

CertsListSidePanelBodyError.propTypes = {
  tab: PropTypes.string.isRequired,
  retriggerApisForError: PropTypes.func,
  handleCloseSidePanel: PropTypes.func,
};

CertsListSidePanelBodyError.defaultProps = {
  retriggerApisForError: () => {},
  handleCloseSidePanel: () => {},
};

export default CertsListSidePanelBodyError;
